const styles = (theme) => ({
    footer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'white',
        // backgroundColor: 'rgba(200,200,200,1)',
        height: '50px',
        opacity: '0.9'
    }
});

export default styles;